export default __webpack_public_path__ + "static/media/lightning.00ef4eb9.svg";